import React from 'react';
import logo from './images/Logo..png';

const Support = () => {
    return (
        <div className="min-h-screen bg-[#F7F8FA] py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto">
                <div className="flex justify-center mb-10">
                    <img src={logo} alt="Fisico da Urlo" className="h-24 w-auto object-contain" />
                </div>

                <div className="bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] rounded-2xl p-8 md:p-12 overflow-hidden">
                    <h1 className="text-3xl font-extrabold text-[#001621] mb-8 text-center border-b pb-6 border-slate-100">
                        Supporto – Fisico da Urlo
                    </h1>

                    <div className="space-y-8 text-slate-600 leading-relaxed text-lg">
                        <section>
                            <p>
                                Per assistenza sull'app Fisico da Urlo, puoi rivolgerti direttamente alla palestra.
                            </p>
                        </section>

                        <section>
                            <p>
                                Se riscontri problemi con il check-in tramite QR code, errori nell'app o difficoltà di accesso, ti invitiamo a contattare lo staff della palestra, che sarà lieto di aiutarti.
                            </p>
                        </section>

                        <section>
                            <p>
                                Per richieste tecniche o segnalazioni, puoi anche inviare una comunicazione tramite i canali ufficiali della palestra.
                            </p>
                        </section>

                        <section>
                            <p>
                                Ci impegniamo a garantire un'esperienza semplice, veloce e affidabile per tutti i membri.
                            </p>
                        </section>
                    </div>
                </div>

                <div className="text-center mt-8 text-slate-400 text-sm">
                    &copy; {new Date().getFullYear()} Fisico da Urlo. Tutti i diritti riservati.
                </div>
            </div>
        </div>
    );
};

export default Support;
